import {AppAction} from '../../appActions';
import {RecentCommunicationsActionsEnum} from './recentCommunicationsActions';
import {
  RecentCommunications,
  RecentCommunicationsBannerStatusesEnum,
  RecentCommunicationsState,
} from './recentCommunicationsState';

/*
 * Reducer.
 */

export function recentCommunicationsReducer(
  state: RecentCommunicationsState = {},
  action: AppAction,
): RecentCommunicationsState {
  switch (action.type) {
    case RecentCommunicationsActionsEnum.SET_RECENT_COMMUNICATIONS: {
      const {contactUid, recentConversations, requestedAt} = action.payload;
      const recentCommunications: RecentCommunications = {
        ...recentConversations,
        requestedAt,
        bannerStatus: RecentCommunicationsBannerStatusesEnum.VISIBLE,
      };
      const newStateForContact = {[contactUid]: recentCommunications};
      return {
        ...state,
        ...newStateForContact,
      };
    }

    case RecentCommunicationsActionsEnum.DISMISS_BANNER: {
      const {contactUid} = action.payload;
      const newStateForContact = {
        [contactUid]: {
          ...state[contactUid],
          ...{bannerStatus: RecentCommunicationsBannerStatusesEnum.DISMISSED},
        },
      };
      return {
        ...state,
        ...newStateForContact,
      };
    }

    case RecentCommunicationsActionsEnum.CLICK_BANNER: {
      const {contactUid} = action.payload;
      const newStateForContact = {
        [contactUid]: {
          ...state[contactUid],
          ...{bannerStatus: RecentCommunicationsBannerStatusesEnum.BANNER_CLICKED},
        },
      };
      return {
        ...state,
        ...newStateForContact,
      };
    }

    case RecentCommunicationsActionsEnum.MARK_HIGHLIGHT_AS_VIEWED: {
      const {contactUid} = action.payload;
      const newStateForContact = {
        [contactUid]: {
          ...state[contactUid],
          ...{bannerStatus: RecentCommunicationsBannerStatusesEnum.HIGHLIGHT_VIEWED},
        },
      };
      return {
        ...state,
        ...newStateForContact,
      };
    }

    default:
      return state;
  }
}
